import { useState } from "react";

const Controls = ({onPageChange, isNextPageDisabled}) => {
    const [isDropdown, setIsDropdown] = useState(false);

    const toggleDropdown = () => {
        setIsDropdown(!isDropdown);
    }
    
    return (
        <div className="main-list__controls">
                                <div className="main-list__calendar-week-select">
                                    <button className="week-select-btn" type="button" onClick={() => onPageChange("prev")}>
                                        <i className="fa-solid fa-chevron-left"></i>
                                    </button>
                                    {/* <div className="main-list__calendar-week-title">
                                        <div className="main-list__calendar-week-title-dropdown"  onClick={toggleDropdown}>
                                            <div for="calendarDropdown" className="main-list__calendar-dropdown-button">
                                                <span>Nov</span>
                                                <span>2024</span>
                                                <i className="fa-regular fa-chevron-down"></i>
                                            </div>
                                            <div className={`main-list__calendar-dropdown ${isDropdown ? "active" : ""}`}>
                                                <div className="main-list__calendar-dropdown-wrap" id="dropdownMenuScrollbar" data-scrollbar>
                                                    <div className="main-list__calendar-dropdown-item">
                                                        <span>Dec</span>
                                                        <span>2024</span>
                                                    </div>
                                                    <div className="main-list__calendar-dropdown-item">
                                                        <span>Jan</span>
                                                        <span>2025</span>
                                                    </div>
                                                    <div className="main-list__calendar-dropdown-item">
                                                        <span>Feb</span>
                                                        <span>2025</span>
                                                    </div>
                                                    <div className="main-list__calendar-dropdown-item">
                                                        <span>Mar</span>
                                                        <span>2025</span>
                                                    </div>
                                                    <div className="main-list__calendar-dropdown-item">
                                                        <span>Apr</span>
                                                        <span>2025</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="main-list__week-select">
                                            <div>Week</div>
                                            <div>
                                                <span>01.</span>
                                                <span>-</span>
                                                <span>07.</span>
                                            </div>
                                        </div>
                                    </div> */}
                                    <button className="week-select-btn" type="button" onClick={() => onPageChange("next")} disabled={isNextPageDisabled}>
                                        <i className="fa-solid fa-chevron-right"></i>
                                    </button>
                                </div>
                            </div>
    );
};

export default Controls;
